import { serviceEndpoints } from '../../constants';

export enum ScheduleFormType {
  Offer = 'offer',
  Geo = 'geo',
}

export const ScheduleFormConfig = {
  [ScheduleFormType.Offer]: serviceEndpoints.offerSchedule,
  [ScheduleFormType.Geo]: serviceEndpoints.offerGeoSchedule,
};
